import React from "react";
import { useNavigate } from "react-router-dom";

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="py-[50px] md:py-[100px] bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4">
        <div className="max-w-md mx-auto text-center">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg
                className="w-10 h-10 text-yellow-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
            <h1 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800">
              Checkout Cancelled
            </h1>
            <p className="text-gray-600 mb-6">
              Your subscription checkout was cancelled. No charges were made to your
              account.
            </p>
            <p className="text-gray-500 mb-6">
              If you have any questions or need assistance, please don't hesitate
              to contact our support team.
            </p>
            <div className="space-y-3">
              <button
                onClick={() => navigate("/subscription")}
                className="w-full py-3 px-4 darkBlue text-white rounded-xl hover:opacity-90 transition-opacity"
              >
                Try Again
              </button>
              <button
                onClick={() => navigate("/")}
                className="w-full py-3 px-4 border-2 border-gray-800 text-gray-800 rounded-xl hover:bg-gray-100 transition-colors"
              >
                Return Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancel;
